"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicSubscribersDto = exports.TopicDto = void 0;
class TopicDto {
    _id;
    _organizationId;
    _environmentId;
    key;
    name;
    subscribers;
}
exports.TopicDto = TopicDto;
class TopicSubscribersDto {
    _organizationId;
    _environmentId;
    _subscriberId;
    _topicId;
    topicKey;
    externalSubscriberId;
}
exports.TopicSubscribersDto = TopicSubscribersDto;
//# sourceMappingURL=topic.dto.js.map